import { connect } from "react-redux";
import {
  displayReservationMessage,
  getBagItems
} from "../../../state/modules/bag";
import ReservationMessage from "./ReservationMessage";

const mapStateToProps = state => ({
  displayReservationMessage: displayReservationMessage(state),
  items: getBagItems(state)
});

export default connect(mapStateToProps)(ReservationMessage);



// WEBPACK FOOTER //
// ./template/components/MiniBag/ReservationMessage/index.js